import firebase from "../firebase";
import UtilService from "@/services/UtilService";
const partnerCodes = firebase.ref("/partnerCodes");
const partners = firebase.ref("/partners");
const clients = firebase.ref("/clients");
const leads = firebase.ref("/leads");

class PartnerCodesService {
  getAll(userInfo) {
    if (
      userInfo.Role === "Partner Admin" ||
      userInfo.Role === "Partner Staff"
    ) {
      return partnerCodes.orderByChild("Partner").equalTo(userInfo.PartnerId);
    } else {
      return partnerCodes.orderByChild("IsDeleted").equalTo(0);
    }
  }

  getById(Id) {
    var ref = partnerCodes.child("/" + Id);
    return ref;
  }

  create(partnerCode) {
    
          var newPostRef = partnerCodes.push();
          var Id = newPostRef.key;
          const userInfo = JSON.parse(localStorage.getItem("userInfo"));
          partnerCode["Id"] = Id;
          partnerCode["CreatedDate"] = partnerCode[
            "ModifiedDate"
          ] = UtilService.convertUserTimeZoneToUTCWithSeconds(new Date(),userInfo.Timezone);

          return partnerCodes.child(Id).set(partnerCode);
  }

  update(key, partnerCode) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    partnerCode["ModifiedDate"] = UtilService.convertUserTimeZoneToUTCWithSeconds(new Date(),userInfo.Timezone)
    return partnerCodes.child(key).update(partnerCode);
  }

  delete(key) {
    return partnerCodes.child(key).update({
      IsDeleted: 1
    });
  }

  deleteAll() {
    return partnerCodes.remove();
  }

  updateCode(key, code, userid, IsDefault) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    return partnerCodes.child(key).update({
      CodeName: code,
      ModifiedDate: UtilService.convertUserTimeZoneToUTCWithSeconds(new Date(),userInfo.Timezone),
      ModifiedBy: userid,
      IsDefault: IsDefault ? IsDefault : false
    });
  }

  incCodeCount(id) {
    let codeModel = {};
    let count;
    return partners
      .orderByChild("Id")
      .equalTo(id)
      .once("value", snapshot => {
        if (snapshot.exists()) {
          codeModel = { ...snapshot.val() };
          if (codeModel[id].CodeCount) {
            count = codeModel[id].CodeCount;
            count = count + 1;
            return partners.child(id).update({
              CodeCount: count
            });
          } else {
            count = 0;
            count = count + 1;
            return partners.child(id).update({
              CodeCount: count
            });
          }
        }
      });
  }

  decCodeCount(id) {
    let codeModel = {};
    let count;
    return partners
      .orderByChild("Id")
      .equalTo(id)
      .once("value", snapshot => {
        if (snapshot.exists()) {
          codeModel = { ...snapshot.val() };
          if (codeModel[id].CodeCount) {
            count = codeModel[id].CodeCount;
            count = count - 1;
            return partners.child(id).update({
              CodeCount: count
            });
          } else {
            count = 0;
            return partners.child(id).update({
              CodeCount: count
            });
          }
        }
      });
  }

  checkDuplicateCode(code, callback) {
    if (code !== "") {
      partnerCodes
        .orderByChild("CodeName")
        .equalTo(code)
        .once("value", snapshot => {
        let isCodeExist = false;
        const userInfo = JSON.parse(localStorage.getItem("userInfo"));
        snapshot.forEach(item => {
          let data = item.val();
          let today = UtilService.convertUserTimeZoneToUTC(new Date(),userInfo.Timezone);
          if (
            data["IsDeleted"] == 0 &&
            (data["Primary"] === "Yes" ||
              (data["ExpiryDate"] && Date(UtilService.convertUserTimeZoneToUTC(new Date(data["ExpiryDate"]),userInfo.Timezone)) >= Date(today)))
          ) {
            isCodeExist = true;
          }
        });

        callback(isCodeExist);
      })
    } else {
      callback(null);
    }
  }

  getCodesVal(id) {
    return partnerCodes.orderByChild("Partner").equalTo(id)
  }

  getCodesId(code) {
    return partnerCodes.orderByChild("CodeName").equalTo(code)
  }

  getPartnerVal()
  {
    return partners
  }

  getPartnerName(id){
    return partners.orderByChild("Id").equalTo(id)
  }

  getPartnerIdFromCodes(id){
    return partnerCodes.orderByChild("Id").equalTo(id)
  }
  
  checkInClient(id){
    return clients.orderByChild("Code").equalTo(id) 
  }
  
  checkInLead(id){
    return leads.orderByChild("Code").equalTo(id) 
  }

  checkIfCodeExists(code) {
    return partnerCodes
      .orderByChild("CodeName")
      .equalTo(code)
      .once("value", snapshot => {
        if (snapshot.exists()) {
          return null;
        }
      });
  }
}

export default new PartnerCodesService();
